/**
 * payloadFixtureId.js — the clicked game's fixture id, only while the search
 * is still for that game.
 *
 * A ticker click leaves { query, fixtureId } on the route. A later typed
 * search ("spurs sgp") sent to the background carried that id, and the
 * backend served the clicked game's parlays (Cavaliers @ 76ers, Leo, Oct 22
 * 2026). The foreground search already checked the query; background
 * hand-offs now use the same rule.
 */
export function payloadFixtureId(routePayload, query) {
  const payloadQuery = String(routePayload?.query || '').toLowerCase().trim();
  const currentQuery = String(query || '').toLowerCase().trim();
  const matches = !!payloadQuery && !!currentQuery && (
    currentQuery === payloadQuery ||
    currentQuery.startsWith(payloadQuery) ||
    payloadQuery.startsWith(currentQuery)
  );
  return matches ? (routePayload?.fixtureId || routePayload?.fixture_id || null) : null;
}
